/* eslint-disable no-unused-vars */
import '../css/login.css';
import { commonrequest as get } from '../services/ApiCall.js';
import { BACKEND_URL } from '../services/helper.js';
import { QrScanner } from '@yudiel/react-qr-scanner';
import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import _debounce from 'lodash/debounce';
import axios from 'axios';
import Confetti from 'react-confetti';
import { useWindowSize } from 'react-use'; // For responsive confetti

const Login = () => {
  const location = useLocation();
  const { width, height } = useWindowSize();

  const [modalPopUp, setModalPopUp] = useState(false);
  const [scanning, setScanning] = useState(true);
  const [code, setCode] = useState({
    code: '',
    phNumber: location.state?.phNum,
    userName: location.state?.userName
  });
  const [message, setMessage] = useState('');
  const [header, setHeader] = useState('');
  const [background, setBackground] = useState('');
  const [audioSuccess] = useState(new Audio('/assets/success.mp3'));
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('login') !== 'true') {
      window.location.href = '/login';
    }
  }, []);

  const sendSMS = async (to, message) => {
    try {
      const response = await fetch(`${BACKEND_URL}/send-sms`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to, message })
      });
      const data = await response.json();
    } catch (error) {
      // error handling
    }
  };

  const handleCodeVerify = useCallback(async () => {
    try {
      if (code?.code?.length !== 10) {
        setMessage("Coupon code must be 10 digits");
        setHeader('')
        setBackground('red');
        setModalPopUp(true);
        return;
      }
      const result = await axios.post(
        `${BACKEND_URL}/verify-coupon`,
        { code },
        { headers: { 'Content-Type': 'application/json' } }
      );
      if (result.data?.success) {
        setModalPopUp(true);
        setMessage(result?.data?.message);
        setHeader(result?.data?.heading)
        setBackground('green');
        setShowConfetti(true); // Start confetti

        // Optionally send SMS:
        // const smsMessage = `Hello ${code.userName}, your coupon code ${code.code} has been successfully redeemed!`;
        // sendSMS(code.phNumber, smsMessage);
      } else {
        setMessage(result.data?.error);
        setBackground(result.data?.colour);
        setHeader(result?.data?.heading)
        setShowConfetti(false);
        setModalPopUp(true);
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
      setHeader("")
      setBackground('red');
      setModalPopUp(true);
      setShowConfetti(false);
    }
  }, [code]);
  const handleQRDecode = _debounce((result) => {
    if (scanning && !modalPopUp) {
      setScanning(false);
      setCode(prevCode => ({ ...prevCode, code: result }));
    }
  }, 100);

  useEffect(() => {
    if (code?.code?.length === 10) {
      handleCodeVerify();
    }
  }, [code.code, handleCodeVerify]);

  const onHide = () => {
    setModalPopUp(false);
    if (header?.includes('Congratulations!')) {
            audioSuccess.play().catch(error => {
                console.error('Error playing audio:', error);
            });
         }
    setMessage('');
    setHeader('')
    setScanning(true);
    setShowConfetti(false); // Stop confetti on modal close
  };

  return (
    <div className='container-login100'>
      <div className="wrap-login100">
        <div className='login100-form-title'>
          <h4 style={{ opacity: 1, color: background }}>{message}</h4>
          <h5>Enter your coupon code below:</h5>
          <input
            className='input100'
            type='text'
            pattern="[0-9]*"
            placeholder='Enter 10 digit code'
            maxLength={10}
            value={code.code}
            onChange={(e) =>
              setCode({ ...code, code: e.target.value.replace(/\D/g, '') })
            }
          />
          <button className='login100-form-btn' onClick={handleCodeVerify}>
            Check
          </button>
          <QrScanner
            onDecode={handleQRDecode}
            onError={(error) => console.log(error?.message)}
          />
        </div>
      </div>
      <Modal
        show={modalPopUp}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5>Coupon {code?.code ? `(${code?.code})` : ""}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {header?.includes("Congratulations") ? (
            <div>
              <div
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  backgroundColor: "#28a745",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 auto 1rem",
                  fontSize: "2.5rem",
                  color: "white"
                }}
              >
                ✓
              </div>
              <h3 style={{ color: "green" }}>
                {header}<span style={{ fontSize: "2.5rem" }}> 🎉🎉</span>
              </h3>
              {/* <h4 style={{ color: "black" }}>Thank you for using CellSteel.</h4> */}
              <h5 style={{ color: "green" }}>{message}</h5>
              {/* <h5>Take a screenshot for your reference.</h5> */}
              <p>Close the popup to proceed with another scan.</p>
            </div>
          ) : (
            <div>
              <div
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  backgroundColor: "#dc3545",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 auto 1rem",
                  fontSize: "2.5rem",
                  color: "white"
                }}
              >
                ✕
              </div>
              <h3 style={{ color: "red" }}>{header}</h3>
              <h5 style={{ color: "black" }}>
               {message}
              </h5>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
        {showConfetti && (
  <Confetti
    width={width}
    height={height}
    recycle={false}
    numberOfPieces={3000}
    gravity={0.2}
    run={showConfetti}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      pointerEvents: 'none',
      zIndex: 9999 // Higher than modal's z-index
    }}
  />
)}
    
    </div>
  );
};

export default Login;
